import React from "react";
import About from "./About";
import Header from "./Header";


export default function MainHeader() {

    return (

        <div className="main_header" id="home">
            <Header/>
            <About/>
        </div>
    );
}   
